import facepaint from 'facepaint'

export const breakpoints =
{
  mobile: 576,
  tablet: 768,
  laptop: 992,
  laptopL: 1200,
  desktop: 1400,
  desktopL: 1800
};

export const mq = facepaint(Object.values(breakpoints).map(bp => `@media (min-width: ${bp}px)`));

export const mediaQuery = <T extends keyof typeof breakpoints>(breakpoint: T) => `@media (min-width: ${breakpoints[breakpoint]}px)`;
